import { mapGetters, mapActions } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";
export default {
    name: "contacts",
    data() {
        return {
            params: {},
        };
    },
    mixins: [dynamicHead],

    created() {
        this.getSeoData("contacts").then(() => {
            this.setPageItem(this.seoData);
        });
        this.getFiliale();
    },
    computed: {
        ...mapGetters({
            contact: "contacts/contacts",
            getFilialList: `branches/branchesList`,
            seoData: "setting/seoData",
        }),
    },
    methods: {
        ...mapActions({
            getSeoData: "setting/GET_SEO_DATA",
        }),
    },
};
